import { BaseSerializer } from './base.serializer'
import { InteractiveContentItemTransition } from 'models/interactive-content-item-transition.model'
import { InteractiveContentItemTransitionSkillSerializer } from './interactive-content-item-transition-skill.serializer'

export class InteractiveContentItemTransitionSerializer extends BaseSerializer<InteractiveContentItemTransition> {
  static SERIALIZABLE_ATTRIBUTES = [
    '_destroy', 'id', 'name', 'itemId', 'nextItemId', 'timeout','comment', 'orderNumber', 'gesture', 
    'swipeDirection', 'startTime', 'endTime', 'leftX', 'leftY', 'rightX', 'rightY', 'transitionSkills'
  ]

  static SERIALIZERS = {
    transitionSkills: InteractiveContentItemTransitionSkillSerializer,
  }

  static SERIALIZE_RENAME_KEYS = {
    itemId: 'interactiveContentItemId',
    nextItemId: 'nextInteractiveContentItemId',
    transitionSkills: 'transitionSkillsAttributes'
  }

  static DESERIALIZERS = {
    transitionSkills: InteractiveContentItemTransitionSkillSerializer
  }

  static DESERIALIZE_RENAME_KEYS = {}

  static initializeObject(attributes: Object): InteractiveContentItemTransition {
    return new InteractiveContentItemTransition(attributes)
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/serializers/interactive-content-item-transition.serializer.ts